/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var Shipment;
(function (Shipment) {
    let cargo_type;
    (function (cargo_type) {
        cargo_type["LIGHTWEIGHT"] = "lightweight";
        cargo_type["AVERAGE"] = "average";
        cargo_type["HEAVYWEIGHT"] = "heavyweight";
        cargo_type["CONTAINER_ONLY"] = "container_only";
    })(cargo_type = Shipment.cargo_type || (Shipment.cargo_type = {}));
})(Shipment || (Shipment = {}));
//# sourceMappingURL=Shipment.js.map